var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-check",class:{'z-chk': _vm.checkState, 'z-dis': _vm.disabled},on:{"click":function($event){$event.stopPropagation();return _vm.clickHandle.apply(null, arguments)}}},[(_vm.checkState)?_c('img',{attrs:{"src":require("@/assets/image/check.png"),"alt":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }